import { useDispatch, useSelector } from 'react-redux';
import { deleteVitals, updateVitals } from '../../../../../store/actions/prescriptionPad';
import { getVitals, getPrescription } from '../../../../../store/selectors/prescriptionPad';
import { VitalsEntity } from '../../../../../store/types/prescription';
import { PAD_V2_CONTAINER } from '../PadContainer';
import { Vitals } from '../../../../common/Icons';
import { removeUnwatedKeys } from './VitalAutoSuggest';
import VitalsCardPadV2 from './VitalsCardPadV2';
import { useEffect, useState } from 'react';
import { GVitals } from '../../../../../store/db';
import { getGLocal } from '../../../../../store/idbHandler';
import { DB_TABLES } from '../../../../../store/dbTables';
import { getVitalsPadConfig } from '../../../../../store/selectors/session';

const VitalsCard: React.FC = () => {
    const dispatch = useDispatch();
    const elements = useSelector(getVitals);
    const vitalsIcon = Vitals();
    const prescription = useSelector(getPrescription);
    const [gVitalData, setGVitalData] = useState<GVitals[]>([]);
    const vitalConfig = useSelector(getVitalsPadConfig);

    useEffect(() => {
        if (!prescription?.doctor._id) {
            return;
        }

        getGLocal<GVitals>(prescription?.doctor._id, DB_TABLES['vitals'])
            .then((data) => {
                setGVitalData(data);
            })
            .catch((err) => {
                console.error(err);
            });
    }, [prescription?.doctor._id, vitalConfig]);

    const onElementUpdate = (option: VitalsEntity, index?: number) => {
        dispatch(updateVitals(removeUnwatedKeys(option), index));
    };

    const onElementDelete = (id: string) => {
        dispatch(deleteVitals(id));
    };

    return (
        <VitalsCardPadV2
            icon={vitalsIcon}
            heading={'Vitals'}
            containerId={PAD_V2_CONTAINER}
            onElementDelete={onElementDelete}
            onElementUpdate={onElementUpdate}
            elements={elements}
            gVitalData={gVitalData}
        />
    );
};

export default VitalsCard;
